// Store previous focus element for cart
let previousCartFocus = null;

function rebuildCart(state) {
    
    let items_div = ''

    for (let item of state.items) {

        // Parse variant title to extract Size and Color
        // Shopify variant_title format examples:
        // - "Bright White/All Black / XS" (Color combinations / Size)
        // - "Black / Small" (Color / Size)
        // - "XS" (Size only)
        // - "Red / Medium / Cotton" (Color / Size / Material)
        let variantDisplay = ''
        if (item.variant_title) {
            // Split by "/" and trim each part
            const parts = item.variant_title.split('/').map(p => p.trim()).filter(p => p)
            
            // Size pattern - matches standard sizes (usually the last part)
            const sizePattern = /^(XS|S|M|L|XL|XXL|XXXL|XXS|Small|Medium|Large|Extra Small|Extra Large|2X|3X|\d+)$/i
            
            let size = ''
            let color = ''
            const otherVariants = []
            
            // Strategy: Last part is usually size, everything before is color/material
            if (parts.length > 0) {
                const lastPart = parts[parts.length - 1]
                
                // Check if last part is a size
                if (sizePattern.test(lastPart)) {
                    size = lastPart
                    // Everything before the size is color/material
                    if (parts.length > 1) {
                        const colorParts = parts.slice(0, -1)
                        color = colorParts.join(' / ')
                    }
                } else {
                    // Last part is not a size, check all parts
                    // Try to find size anywhere
                    for (let i = parts.length - 1; i >= 0; i--) {
                        if (sizePattern.test(parts[i]) && !size) {
                            size = parts[i]
                            // Everything before size is color
                            if (i > 0) {
                                color = parts.slice(0, i).join(' / ')
                            }
                            // Everything after size is other variants
                            if (i < parts.length - 1) {
                                otherVariants.push(...parts.slice(i + 1))
                            }
                            break
                        }
                    }
                    
                    // If no size found, treat all as color/other
                    if (!size && parts.length > 0) {
                        color = parts.join(' / ')
                    }
                }
            }
            
            // Build variant display with labels
            if (size) {
                variantDisplay += `<div>Size: ${size}</div>`
            }
            if (color) {
                variantDisplay += `<div>Color: ${color}</div>`
            }
            // Handle other variants (Material, etc.)
            for (const variant of otherVariants) {
                // Try to infer label from variant name
                const variantLabel = variant.includes('Cotton') || variant.includes('Polyester') || variant.includes('Wool') || variant.includes('Linen') || variant.includes('Silk') 
                    ? 'Material' 
                    : 'Option'
                variantDisplay += `<div>${variantLabel}: ${variant}</div>`
            }
            
            // Fallback: if we couldn't parse, show the original variant title
            if (!variantDisplay && item.variant_title) {
                variantDisplay = `<div>${item.variant_title}</div>`
            }
        }

        // Process properties (excluding variant info already displayed)
        let properties = ''
        for (const prop in item.properties) {
            // Skip Final Sale as it's handled separately
            if (prop !== 'Final Sale') {
            properties += prop + ': ' + item.properties[prop] + '<br />'
            }
        }

      	let tags = ''
        
        if (item.properties['Final Sale']) {
            tags = '<span style="color:#c40000;">Final Sale</span><br />'
        }
        
        // Format price with .00
        const price = (item.price / 100).toFixed(2)
        const priceAria = `$${price} dollars`

        const img = item.image ? item.image : '//cdn.shopify.com/s/files/1/0412/1994/8701/files/Screen_Shot_2021-03-04_at_2_59_16_PM.png'
        
        // Get remove icon URL from cart container data attribute
        const cartContainer = document.querySelector('.js-cart')
        const removeIconUrl = cartContainer ? cartContainer.getAttribute('data-remove-icon') : ''
        
        // Build full product description for screen readers (product name + variants)
        let fullProductDescription = item.product_title
        
        // Extract variant text from HTML
        let variantTextForAria = ''
        if (variantDisplay) {
            // Remove HTML tags and clean up whitespace
            variantTextForAria = variantDisplay.replace(/<[^>]*>/g, '')
                .replace(/\n/g, ' ')
                .replace(/\s+/g, ' ')
                .trim()
            
            // If we have variant text, add it to the description
            if (variantTextForAria) {
                fullProductDescription += ', ' + variantTextForAria
            }
        }
        
        // Fallback: if no variantDisplay but we have variant_title, use it directly
        if (!variantTextForAria && item.variant_title && item.variant_title !== 'Default Title') {
            fullProductDescription += ', ' + item.variant_title
            variantTextForAria = item.variant_title
        }
        
        // Debug logging to verify full product description is built correctly
        console.log('=== CART ITEM DEBUG ===');
        console.log('Full item object:', JSON.stringify(item, null, 2));
        console.log('Product title (raw):', item.product_title);
        console.log('Variant title (raw):', item.variant_title);
        console.log('Variant display (HTML):', variantDisplay);
        console.log('Variant text for ARIA (cleaned):', variantTextForAria);
        console.log('Full product description (final):', fullProductDescription);
        console.log('Item key:', item.key);
        console.log('========================');
        
        // Remove button aria label
        const removeAriaLabel = `Remove ${fullProductDescription} from cart`

        items_div += `
            <div class='flex mb-4 pb-4 border-beige border-b cart-item'>
                <div class='mr-4'>
                    <div class='w-32'>
                        <div class='w-full cart-image-container h-0 relative' style='padding-top: 125%;'>
                            <img src='${img}' class='w-full absolute inset-0 h-full object-cover cart-item-image' alt='${item.product_title}' />
                        </div>
                    </div>
                </div>
                <div class='text-14px flex flex-col flex-auto'>
                    <div class='block text-16px tracking-1px mb-2 js-cart-item-title cart-item-title' data-item-key='${item.key}' data-full-description='${fullProductDescription}'>
                        <h2 tabindex='0' class='focus:outline-2 focus:outline-blue-600 focus:outline-offset-2'>
                            <span class='sr-only'>Product: </span>
                            <strong aria-hidden='false'>${item.product_title}</strong>
                            ${variantTextForAria ? `<span class='sr-only'>, ${variantTextForAria}</span>` : ''}
                            ${properties ? `<span class='sr-only'>, ${properties.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim()}</span>` : ''}
                            <span class='sr-only'>, Price $${price}</span>
                        </h2>
                    </div>
                    ${variantDisplay ? `<div class='block mb-2 cart-item-variants' aria-label='Product options: ${variantDisplay.replace(/<[^>]*>/g, '')}'>${variantDisplay}</div>` : ''}
                    ${properties ? `<div class='block mb-2 flex-auto leading-snug' aria-label='Product details: ${properties.replace(/<[^>]*>/g, '')}'>${properties}</div>` : ''}
                    ${tags ? `<div class='block mb-2'>${tags}</div>` : ''}
                    <div class='block mb-2'>
                        <div aria-label='Unit price: $${price}'>$${price}</div>
                    </div>
                    <div class='flex items-center justify-between w-full'>
                        <div role='group' aria-label='Quantity controls for ${fullProductDescription}' class='flex items-center'>
                            <button type='button' class='js-minus outline-none px-3 cart-quantity-btn' data-key='${item.key}' aria-label='Product: ${fullProductDescription}${properties ? ', ' + properties.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim() : ''}, Price $${price}. Remove 1 unit from bag' aria-controls='quantity-${item.key}'>
                                <span aria-hidden='true'>-</span>
                                <span class='sr-only'>Remove 1 unit</span>
                            </button>
                            <span 
                                id='quantity-${item.key}'
                                class='px-4 cart-quantity-value' 
                                tabindex='0'
                                role='status' 
                                aria-live='polite'
                                aria-atomic='true'
                                aria-label='Product: ${fullProductDescription}${properties ? ', ' + properties.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim() : ''}, Price $${price}. Quantity: ${item.quantity} ${item.quantity === 1 ? 'item' : 'items'} in bag'
                                data-item-key='${item.key}'
                                data-item-title='${fullProductDescription}'
                                data-item-price='${price}'
                            >${item.quantity}</span>
                            <button type='button' class='js-plus outline-none px-3 cart-quantity-btn' data-key='${item.key}' aria-label='Product: ${fullProductDescription}${properties ? ', ' + properties.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim() : ''}, Price $${price}. Add 1 unit to bag' aria-controls='quantity-${item.key}'>
                                <span aria-hidden='true'>+</span>
                                <span class='sr-only'>Add 1 unit</span>
                            </button>
                        </div>
                        <button type='button' class='js-remove flex items-center justify-center cart-remove-btn' data-key='${item.key}' aria-label='Remove all ${fullProductDescription} from cart' data-item-title='${fullProductDescription}'>
                            ${removeIconUrl ? `<img src='${removeIconUrl}' class='w-4 h-4' aria-hidden='true' alt='' />` : '<span aria-hidden="true">×</span>'}
                            <span class='sr-only'>Remove all items</span>
                        </button>
                    </div>
                </div>
            </div>
        `
    }

    // Set cart as busy during rebuild
    const cartContainer = document.querySelector('.js-cart');
    if (cartContainer) {
        cartContainer.setAttribute('aria-busy', 'true');
    }

    document.querySelector('.js-items').innerHTML = items_div
    const totalPrice = (state.total_price / 100).toFixed(2)
    document.querySelector('.js-price').innerHTML = '$' + totalPrice
    document.querySelector('.js-price').setAttribute('aria-label', `Total: $${totalPrice} dollars`)
    
    // Update cart title with item count for screen readers
    const cartTitle = document.querySelector('#cart-title');
    if (cartTitle) {
        const itemCount = state.item_count;
        const itemText = itemCount === 1 ? 'item' : 'items';
        cartTitle.setAttribute('aria-label', `Shopping cart: ${itemCount} ${itemText}`);
    }
    
    // Clear busy state
    if (cartContainer) {
        cartContainer.removeAttribute('aria-busy');
    }
    
    // CRITICAL: Ensure info icon, checkout+ button, and discount link are in tab order
    setTimeout(() => {
        setupCartTabOrder();
        setupQuantityKeyboardHandlers();
        // Update button aria-labels immediately and again after a short delay to ensure DOM is ready
        updateButtonAriaLabels();
        setTimeout(() => {
            updateButtonAriaLabels();
        }, 100);
        setTimeout(() => {
            updateButtonAriaLabels();
        }, 500);
    }, 500);

    // Don't auto-focus product title after cart updates - let user maintain their focus position
    // if (typeof window.focusCartItemTitle === 'function') {
    //     window.focusCartItemTitle(state.item_count);
    // }

    const counts = document.querySelectorAll('.js-count')

    for (const count of counts) {
        count.innerHTML = state.item_count
    }

    const minus_elements = document.querySelectorAll('.js-minus')
        
    for (const minus of minus_elements) {
        // Ensure button is keyboard accessible
        minus.setAttribute('tabindex', '0');
        
        // Click handler - use once: false so it works every time
        minus.addEventListener('click', async function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            const key = this.dataset.key;
            
            if (!key) {
                console.error('Minus button missing data-key attribute');
                return;
            }
            
            // Get current state from API instead of using closure variable
            const currentState = await Shopify.theme.cart.getState();
            const item = currentState.items.find(item => item.key === key);

            if (!item) return;

            // Get full product description from data attribute
            const quantityValue = document.getElementById(`quantity-${key}`) || document.querySelector(`[id="quantity-${key}"]`);
            const fullProductDescription = quantityValue ? (quantityValue.getAttribute('data-item-title') || item.product_title) : item.product_title;

            const quantity = (item.quantity <= 1) ? 0 : (item.quantity - 1);
            
            // Set loading state - use getElementById or attribute selector to handle special characters in key
            if (quantityValue) {
                quantityValue.setAttribute('aria-busy', 'true');
            }
            
            // Announce update in progress
            announceToScreenReader(`Removing 1 unit of ${fullProductDescription} from bag...`);

            Shopify.theme.cart.updateItem(key, { quantity }).then(async (state) => {
                // Announce quantity change BEFORE rebuilding to prevent focus shift
                const updatedItem = state.items.find(item => item.key === key);
                if (updatedItem) {
                    const updatedPrice = (updatedItem.price / 100).toFixed(2);
                    const lineTotal = (updatedItem.line_price / 100).toFixed(2);
                    announceToScreenReader(`Removed 1 unit of ${fullProductDescription}. Now ${updatedItem.quantity} ${updatedItem.quantity === 1 ? 'item' : 'items'} in bag. Line total: $${lineTotal}`);
                } else {
                    // Item was removed (quantity became 0)
                    announceToScreenReader(`Removed all ${fullProductDescription} from bag. Item removed from cart.`);
                }
                
                // Small delay to ensure announcement is heard before rebuild
                setTimeout(() => {
                  rebuildCart(state);	
                }, 300);
                
                // Clear loading state
                if (quantityValue) {
                    quantityValue.removeAttribute('aria-busy');
                }
            }).catch(function (e) {
                console.error('Error updating cart:', e);
                announceToScreenReader(`Unable to update quantity for ${item.product_title}. Please try again.`, 'assertive');
                if (quantityValue) {
                    quantityValue.removeAttribute('aria-busy');
                }
            });
        }, { once: false });
        
        // Add keyboard handlers: Enter and Space to decrease quantity
        minus.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                this.click();
            }
        }, { once: false });
    }

    const plus_elements = document.querySelectorAll('.js-plus')
        
    for (const plus of plus_elements) {
        // Ensure button is keyboard accessible
        plus.setAttribute('tabindex', '0');
        
        // Click handler
        plus.addEventListener('click', async function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            const key = this.dataset.key;
            
            if (!key) {
                console.error('Plus button missing data-key attribute');
                return;
            }
            
            // Get current state from API instead of using closure variable
            const currentState = await Shopify.theme.cart.getState();
            const item = currentState.items.find(item => item.key === key);
            
            if (!item) return;

            // Get full product description from data attribute
            const quantityValue = document.getElementById(`quantity-${key}`) || document.querySelector(`[id="quantity-${key}"]`);
            const fullProductDescription = quantityValue ? (quantityValue.getAttribute('data-item-title') || item.product_title) : item.product_title;

            const quantity = item.quantity + 1;
            
            // Set loading state - use getElementById or attribute selector to handle special characters in key
            if (quantityValue) {
                quantityValue.setAttribute('aria-busy', 'true');
            }
            
            // Announce update in progress
            announceToScreenReader(`Adding 1 unit of ${fullProductDescription} to bag...`);

            Shopify.theme.cart.updateItem(key, { quantity }).then(async (state) => {
                const new_item = state.items.find(item => item.key === key);

                if (new_item && new_item.quantity == item.quantity) {
                    // Inventory limit reached
                    const errorMsg = `Cannot add more ${fullProductDescription}. Maximum quantity of ${item.quantity} reached.`;
                    alert(errorMsg);
                    announceToScreenReader(errorMsg, 'assertive');
                } else if (new_item) {
                    // Successfully updated with clear announcement
                    const updatedPrice = (new_item.price / 100).toFixed(2);
                    const lineTotal = (new_item.line_price / 100).toFixed(2);
                    announceToScreenReader(`Added 1 unit of ${fullProductDescription}. Now ${new_item.quantity} ${new_item.quantity === 1 ? 'item' : 'items'} in bag. Line total: $${lineTotal}`);
                }

                // Rebuild immediately with returned state
                    rebuildCart(state);	
              
                // Clear loading state
                if (quantityValue) {
                    quantityValue.removeAttribute('aria-busy');
                }
            }).catch(function (e) {
                const errorMsg = `No further inventory available for ${item.product_title}. Please try again.`;
                alert(errorMsg);
                announceToScreenReader(errorMsg, 'assertive');
                if (quantityValue) {
                    quantityValue.removeAttribute('aria-busy');
                }
            });
        }, { once: false });
        
        // Add keyboard handlers: Enter and Space to increase quantity
        plus.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                this.click();
            }
        }, { once: false });
    }

    const remove_elements = document.querySelectorAll('.js-remove')

    for (const remove of remove_elements) {
        // Ensure button is keyboard accessible
        remove.setAttribute('tabindex', '0');
        
        // Click handler
        remove.addEventListener('click', async function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            const key = this.dataset.key;
            
            if (!key) {
                console.error('Remove button missing data-key attribute');
                return;
            }
            
            // Get full product description from data attribute (should already include variants)
            const itemTitle = this.getAttribute('data-item-title') || 'item';
            const fullProductDescription = itemTitle;

            // Set loading state - use getElementById or attribute selector to handle special characters in key
            const quantityValue = document.getElementById(`quantity-${key}`) || document.querySelector(`[id="quantity-${key}"]`);
            if (quantityValue) {
                quantityValue.setAttribute('aria-busy', 'true');
            }
            
            // Announce removal in progress
            announceToScreenReader(`Removing all ${fullProductDescription} from bag...`);

            Shopify.theme.cart.removeItem(key).then(async(state) => {	
                // Announce removal complete BEFORE rebuilding cart to prevent focus shift
                const cartTotal = (state.total_price / 100).toFixed(2);
                announceToScreenReader(`Removed all ${fullProductDescription} from bag. ${state.item_count} ${state.item_count === 1 ? 'item' : 'items'} remaining in cart. Cart total: $${cartTotal}`);
                
                // Small delay to ensure announcement is heard before rebuild
                setTimeout(() => {
                    // Rebuild cart after announcement
                  rebuildCart(state);	
                }, 300);
            }).catch(function (e) {
                console.error('Error removing item:', e);
                announceToScreenReader(`Unable to remove ${itemTitle} from cart. Please try again.`, 'assertive');
                if (quantityValue) {
                    quantityValue.removeAttribute('aria-busy');
                }
            });
        }, { once: false });
        
        // Add keyboard handlers: Enter and Space to remove item
        remove.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                this.click();
            }
        }, { once: false });
    }
  
  $.ajax({
    url: '/cart.json',
    type: 'GET',
    success: function(cart){
      var cart = cart;
      var price = cart.total_price;
      var percent = price/125;
      var amountLeft = 125-(price/100);
      amountLeft = parseFloat(amountLeft, 10).toFixed(2);
      const progressBar = document.querySelector('.thermometer[role="progressbar"]');
      
      if (isNaN(amountLeft)) {
      } else {
        if (percent >= 100) {
          $('.therm-header').show();
          $('.thermometer').show();
          $('.bar.fill-bar:after').show();
          $('.coupon-code').hide();
          $('.bar.fill-bar').animate({'width': '100%', }, 600);
          $('.amountLeft').html("<strong>Congrats! You've got FREE Shipping!</strong>");
          $('#dynamic_shipping').html("Congratulations! You've got FREE Shipping!");
          
          // Update ARIA attributes for completed progress
          if (progressBar) {
            progressBar.setAttribute('aria-valuenow', '125');
            progressBar.setAttribute('aria-label', 'Free shipping progress: Complete! You have free shipping!');
          }
        } else {
          $('.therm-header').show();
          $('.thermometer').show();
          $('.coupon-code').hide();
          $('.bar.fill-bar:after').show();
          $('.bar.fill-bar').animate({
            'width': percent+'%',
          }, 600);
          $('.amountLeft').html("You're <strong>$" + amountLeft + "</strong> away from FREE Shipping!");
          $('#dynamic_shipping').html("You're <strong>$" + amountLeft + "</strong> away from FREE Shipping!");
          
          // Update ARIA attributes for progress
          if (progressBar) {
            const currentValue = (price / 100).toFixed(2);
            progressBar.setAttribute('aria-valuenow', currentValue);
            progressBar.setAttribute('aria-label', `Free shipping progress: $${amountLeft} remaining`);
          }
          
          // Ensure shipping bar doesn't interfere with product announcements
          const amountLeftEl = document.querySelector('.amountLeft');
          if (amountLeftEl) {
            amountLeftEl.setAttribute('aria-live', 'off');
          }
        }
      }
    },
    error: function(){
      console.log('fail');
    }
  });
}




// Shared function to handle add to cart logic
async function handleAddToCart() {
    const items = document.querySelectorAll('.js-item');
    const mainSelect = document.querySelector('[data-option-main]');
    
    console.log('Items found:', items.length);
    console.log('Main select found:', mainSelect ? 'Yes' : 'No', mainSelect ? 'Value: ' + mainSelect.value : '');
    
    let itemsAdded = false;
    
    // Prioritize main select for standard products (even if it has .js-item class)
    if (mainSelect && mainSelect.value) {
        console.log('Using main select - Variant ID:', mainSelect.value);
        try {
            const variantId = parseInt(mainSelect.value);
            const quantityInput = document.querySelector('input[name="quantity"]');
            const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
            
            console.log('Adding to cart - Variant ID:', variantId, 'Quantity:', quantity);
            await Shopify.theme.cart.addItem(variantId, quantity);
            console.log('Successfully added to cart');
            itemsAdded = true;
        } catch (error) {
            console.error('Error adding to cart:', error);
            alert('Unable to add item to cart. Please try again.');
            return false;
        }
    }
    // If we have .js-item elements that are NOT the main select (for special products like jackets, pants, etc.)
    else if (items.length > 0) {
        console.log('Processing .js-item elements');
        for (const item of items) {
            // Skip if this is the main select (already handled above)
            if (item.hasAttribute('data-option-main')) {
                console.log('Skipping main select in .js-item processing');
                continue;
            }
            
            if (item.id == "jacket") {
                const has_jacket = document.getElementById('has_jacket')
                if (has_jacket && has_jacket.checked) {
                    try {
                        await Shopify.theme.cart.addItem(parseInt(item.value))
                        itemsAdded = true;
                    } catch {
                        alert('Out of stock!');
                    }
                }
            } else if (item.id == "pants") {
                const has_pants = document.getElementById('has_pants')
                if (has_pants && has_pants.checked) {
                    try {
                        await Shopify.theme.cart.addItem(parseInt(item.value))
                        itemsAdded = true;
                    } catch {
                        alert('Out of stock!');
                    }
                }
            } else if (item.id == "crease") {
                if (item.checked) {
                    try {
                        await Shopify.theme.cart.addItem(parseInt(item.dataset.value))
                        itemsAdded = true;
                    } catch {
                        alert('Out of stock!');
                    }
                }
            } else if (item.id == "hem") {
                if (item.checked) {
                    try {
                        await Shopify.theme.cart.addItem(parseInt(item.dataset.value))
                        itemsAdded = true;
                    } catch {
                        alert('Out of stock!');
                    }
                }
            } else {
                // Generic .js-item (not main select, not special product)
                try {
                    await Shopify.theme.cart.addItem(parseInt(item.value))
                    itemsAdded = true;
                } catch {
                    alert('Out of stock!');
                }
            }
        }
    }
    // Fallback: no items found
    else {
        console.warn('No items or variant found to add to cart');
        console.warn('Main select:', mainSelect);
        console.warn('Main select value:', mainSelect ? mainSelect.value : 'N/A');
        alert('Please select a variant before adding to cart.');
        return false;
    }

    if (!itemsAdded) {
        console.warn('No items were successfully added to cart');
        return false;
    }

    const state = await Shopify.theme.cart.getState();
    rebuildCart(state);
    document.body.classList.add("cart--open");

    // CRITICAL: Move focus to cart for ADA compliance
    setTimeout(() => {
        focusCartOnOpen();
    }, 100);
    
    return true;
}

// Add to cart handler - ensure it works reliably
let isAddingToCart = false; // Prevent multiple simultaneous adds

function setupAddToCart() {
    console.log('setupAddToCart called');
    
    // Prevent form submission and trigger add to cart
    const addToCartForm = document.querySelector('#AddToCartForm, form.js-form');
    if (addToCartForm && !addToCartForm.hasAttribute('data-cart-form-setup')) {
        addToCartForm.setAttribute('data-cart-form-setup', 'true');
        console.log('Form submit handler attached');
        addToCartForm.addEventListener('submit', async function(e) {
            console.log('=== FORM SUBMIT INTERCEPTED ===');
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();
            
            // Prevent multiple simultaneous adds
            if (isAddingToCart) {
                console.log('Already adding to cart, ignoring duplicate request');
                return false;
            }
            
            isAddingToCart = true;
            try {
                // Trigger add to cart since form submit was prevented
                console.log('Triggering add to cart from form submit');
                await handleAddToCart();
            } finally {
                isAddingToCart = false;
            }
            
            return false;
        }, true); // Use capture phase
    }

    // Use event delegation to catch clicks even if button is recreated
    // Use capture phase to catch clicks before other handlers
    if (!window.addToCartDelegationSetup) {
        window.addToCartDelegationSetup = true;
        console.log('Setting up event delegation for add to cart (capture phase)');
        document.addEventListener('click', async function(e) {
            const addToCartButton = e.target.closest('.js-add-to-cart');
            if (!addToCartButton) return;
            
            // Prevent multiple simultaneous adds
            if (isAddingToCart) {
                console.log('Already adding to cart, ignoring duplicate click');
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                return;
            }
            
            console.log('=== ADD TO CART CLICKED (delegation) ===');
            console.log('Button:', addToCartButton);
            console.log('Button disabled?', addToCartButton.disabled);
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            isAddingToCart = true;
            // Disable button during processing
            if (addToCartButton.disabled === false) {
                addToCartButton.disabled = true;
                const originalText = addToCartButton.textContent || addToCartButton.innerText;
                addToCartButton.setAttribute('data-original-text', originalText);
                addToCartButton.textContent = 'Adding...';
            }
            
            try {
                // Call shared handler function
                await handleAddToCart();
            } finally {
                isAddingToCart = false;
                // Re-enable button
                if (addToCartButton) {
                    addToCartButton.disabled = false;
                    const originalText = addToCartButton.getAttribute('data-original-text');
                    if (originalText) {
                        addToCartButton.textContent = originalText;
                    }
                }
            }
        }, true); // Capture phase - catch before other handlers
    }

    // Also attach direct handler if button exists
    const addToCartButton = document.querySelector('.js-add-to-cart');
    if (addToCartButton && !addToCartButton.hasAttribute('data-cart-handler-attached')) {
        addToCartButton.setAttribute('data-cart-handler-attached', 'true');
        console.log('Direct handler attached to button:', addToCartButton);
        addToCartButton.addEventListener('click', async (e) => {
            // Prevent multiple simultaneous adds
            if (isAddingToCart) {
                console.log('Already adding to cart, ignoring duplicate click');
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                return;
            }
            
            console.log('=== ADD TO CART CLICKED (direct) ===');
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            isAddingToCart = true;
            // Disable button during processing
            if (addToCartButton.disabled === false) {
                addToCartButton.disabled = true;
                const originalText = addToCartButton.textContent || addToCartButton.innerText;
                addToCartButton.setAttribute('data-original-text', originalText);
                addToCartButton.textContent = 'Adding...';
            }
            
            try {
                // Call shared handler function
                await handleAddToCart();
            } finally {
                isAddingToCart = false;
                // Re-enable button
                if (addToCartButton) {
                    addToCartButton.disabled = false;
                    const originalText = addToCartButton.getAttribute('data-original-text');
                    if (originalText) {
                        addToCartButton.textContent = originalText;
                    }
                }
            }
        });
    } else if (addToCartButton) {
        console.log('Button found but handler already attached');
    } else {
        console.log('Add to cart button not found');
    }
}

// Setup when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAddToCart);
} else {
    setupAddToCart();
}

// Also setup after delays to catch dynamically loaded content
setTimeout(setupAddToCart, 100);
setTimeout(setupAddToCart, 500);
setTimeout(setupAddToCart, 1000);

// Function to focus cart when it opens - ADA compliant
function focusCartOnOpen() {
    const cart = document.querySelector('.js-cart');
    if (!cart) return;
    
    // Set cart as focusable and focus it
    cart.setAttribute('tabindex', '-1');
    
    // Try to focus the cart header first (most important element)
    const cartTitle = document.querySelector('#cart-title');
    if (cartTitle) {
        cartTitle.setAttribute('tabindex', '-1');
        cartTitle.focus();
        
        // Announce to screen readers
        announceToScreenReader(`Shopping cart opened with ${cart.querySelector('.js-count')?.textContent || '0'} items`);
        
        // Remove tabindex after focus
        setTimeout(() => {
            cartTitle.removeAttribute('tabindex');
        }, 100);
    } else {
        // Fallback: focus the cart container
        cart.focus();
        announceToScreenReader(`Shopping cart opened`);
    }
}

// Setup keyboard handlers for quantity value elements
function setupQuantityKeyboardHandlers() {
    const quantityValues = document.querySelectorAll('.cart-quantity-value');
    
    quantityValues.forEach(quantityValue => {
        // Remove existing listeners to prevent duplicates
        const newQuantityValue = quantityValue.cloneNode(true);
        quantityValue.parentNode.replaceChild(newQuantityValue, quantityValue);
        
        // Add keyboard event listeners
        newQuantityValue.addEventListener('keydown', (e) => {
            const itemKey = newQuantityValue.getAttribute('data-item-key');
            const minusBtn = document.querySelector(`.js-minus[data-key="${itemKey}"]`);
            const plusBtn = document.querySelector(`.js-plus[data-key="${itemKey}"]`);
            
            // Arrow keys to change quantity
            if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
                e.preventDefault();
                if (minusBtn) {
                    minusBtn.focus();
                    minusBtn.click();
                }
            } else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
                e.preventDefault();
                if (plusBtn) {
                    plusBtn.focus();
                    plusBtn.click();
                }
            }
            // Enter or Space to read current quantity in bag
            else if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                const quantity = newQuantityValue.textContent.trim();
                const itemTitle = newQuantityValue.getAttribute('data-item-title') || 'item';
                const itemPrice = newQuantityValue.getAttribute('data-item-price') || '';
                if (itemPrice) {
                    announceToScreenReader(`Quantity: ${quantity} ${quantity === '1' ? 'item' : 'items'} in bag for ${itemTitle}, unit price $${itemPrice}`);
                } else {
                    announceToScreenReader(`Quantity: ${quantity} ${quantity === '1' ? 'item' : 'items'} in bag for ${itemTitle}`);
                }
            }
        });
        
        // Add focus handler to announce current quantity in bag
        newQuantityValue.addEventListener('focus', () => {
            const quantity = newQuantityValue.textContent.trim();
            const itemTitle = newQuantityValue.getAttribute('data-item-title') || 'item';
            const itemPrice = newQuantityValue.getAttribute('data-item-price') || '';
            // Small delay to ensure screen reader picks up the aria-label first
            setTimeout(() => {
                if (itemPrice) {
                    announceToScreenReader(`Quantity: ${quantity} ${quantity === '1' ? 'item' : 'items'} in bag for ${itemTitle}, unit price $${itemPrice}`);
                } else {
                    announceToScreenReader(`Quantity: ${quantity} ${quantity === '1' ? 'item' : 'items'} in bag for ${itemTitle}`);
                }
            }, 100);
        });
    });
}

// Setup proper tab order: info icon -> ReDo checkout -> discount link
// Note: ReDo uses closed shadow DOM, so we can only interact with the host element <redo-shopify-toggle>
function setupCartTabOrder() {
    const cart = document.querySelector('.js-cart');
    if (!cart) return;
    
    // Find discount link (already in template)
    const discountLink = cart.querySelector('a[href="/checkout"]:not([class*="checkout"]):not([id*="checkout"])');
    
    // Find ReDo custom element (closed shadow root - we can only access the host)
    const redoToggle = cart.querySelector('redo-shopify-toggle');
    
    // Find info icon - simple search for info-related elements
    const footer = cart.querySelector('.py-4.block.w-full') || cart;
    let infoIcon = null;
    const infoElements = footer.querySelectorAll('[aria-label*="info" i], [aria-label*="help" i], [title*="info" i], button[class*="info"], a[class*="info"]');
    for (const el of infoElements) {
        if (!el.classList.contains('js-close-cart') && 
            !el.classList.contains('js-remove') &&
            el.offsetWidth > 0 && el.offsetHeight > 0) {
            infoIcon = el;
            break;
        }
    }
    
    // Make info icon focusable (only process once per element)
    if (infoIcon && !infoIcon.hasAttribute('data-cart-tab-processed')) {
        infoIcon.setAttribute('data-cart-tab-processed', 'true');
        if (infoIcon.tagName !== 'BUTTON' && infoIcon.tagName !== 'A') {
            if (!infoIcon.hasAttribute('tabindex')) {
                infoIcon.setAttribute('tabindex', '0');
            }
            infoIcon.setAttribute('role', 'button');
            if (!infoIcon.getAttribute('aria-label')) {
                infoIcon.setAttribute('aria-label', 'More information');
            }
        } else if (infoIcon.getAttribute('tabindex') === '-1') {
            infoIcon.removeAttribute('tabindex');
        }
    }
    
    // CRITICAL: Ensure ReDo host is focusable and in tab order
    if (redoToggle) {
        // Remove any negative tabindex
        if (redoToggle.getAttribute('tabindex') === '-1') {
            redoToggle.removeAttribute('tabindex');
        }
        // Force tabindex="0" to ensure it's in tab order
        redoToggle.setAttribute('tabindex', '0');
        // Remove aria-hidden if present
        if (redoToggle.hasAttribute('aria-hidden')) {
            redoToggle.removeAttribute('aria-hidden');
        }
        // Mark as processed
        if (!redoToggle.hasAttribute('data-cart-tab-processed')) {
            redoToggle.setAttribute('data-cart-tab-processed', 'true');
        }
    }
    
    // Make discount link focusable
    if (discountLink && !discountLink.hasAttribute('data-cart-tab-processed')) {
        discountLink.setAttribute('data-cart-tab-processed', 'true');
        if (discountLink.getAttribute('tabindex') === '-1') {
            discountLink.removeAttribute('tabindex');
        }
        // Links are already focusable, don't add tabindex
    }
}

// Function to announce changes to screen readers
// Update button aria-labels to ensure they have the full product description
function updateButtonAriaLabels() {
    console.log('=== updateButtonAriaLabels called ===');
    const cart = document.querySelector('.js-cart');
    if (!cart) {
        console.warn('Cart not found');
        return;
    }
    
    const quantityValues = cart.querySelectorAll('.cart-quantity-value');
    console.log('Found quantity values:', quantityValues.length);
    
    if (quantityValues.length === 0) {
        console.warn('No quantity values found in cart');
        return;
    }
    
    quantityValues.forEach((quantityValue, index) => {
        const itemKey = quantityValue.getAttribute('data-item-key');
        const fullProductDescription = quantityValue.getAttribute('data-item-title');
        
        console.log(`\n--- Quantity value ${index} ---`);
        console.log('Item key:', itemKey);
        console.log('Full product description:', fullProductDescription);
        console.log('Current aria-label:', quantityValue.getAttribute('aria-label'));
        
        if (!itemKey) {
            console.error('Missing itemKey for quantity value:', quantityValue);
            return;
        }
        
        // Check if fullProductDescription is just the product title (missing variants)
        const quantityValueText = quantityValue.textContent || '';
        if (!fullProductDescription || fullProductDescription.length < 10) {
            console.warn('Full product description missing or too short:', {
                fullProductDescription: fullProductDescription,
                expectedToInclude: 'variants'
            });
        }
        
        // Find the cart item container by traversing up from the quantity value
        const cartItem = quantityValue.closest('.cart-item');
        if (!cartItem) {
            console.error('✗ Cart item container not found for quantity value:', quantityValue);
            return;
        }
        
        // Get product details from the product title element - this is the visible element in the cart
        const productTitleEl = cartItem.querySelector('.js-cart-item-title, .cart-item-title');
        let productInfo = '';
        
        // Read directly from the h2 element that's already in the DOM - this is what screen readers see
        if (productTitleEl) {
            const h2 = productTitleEl.querySelector('h2');
            if (h2) {
                // Get all text content including sr-only spans - this is exactly what screen readers read
                // Clone the element to get text without modifying the original
                const clone = h2.cloneNode(true);
                // Remove aria-hidden elements (like the visible strong tag)
                Array.from(clone.querySelectorAll('[aria-hidden="true"]')).forEach(el => el.remove());
                // Get the text content - this includes all sr-only spans with variant info
                productInfo = clone.textContent.trim();
                
                console.log('✓ Extracted productInfo from h2 element:', productInfo);
            } else {
                console.error('✗ H2 element not found in productTitleEl');
            }
        } else {
            console.error('✗ Product title element not found in cart item');
        }
        
        // Fallback: if we couldn't read from DOM, use fullProductDescription from data attribute
        if (!productInfo || productInfo.length < 5) {
            const itemPrice = quantityValue.getAttribute('data-item-price') || '';
            if (fullProductDescription) {
                productInfo = `Product: ${fullProductDescription}${itemPrice ? ', Price $' + itemPrice : ''}`;
                console.log('⚠ Using fallback fullProductDescription:', productInfo);
            } else {
                // Last resort: just use what we have
                productInfo = `Product: ${itemKey}`;
                console.warn('⚠ Could not extract product info, using itemKey as fallback');
            }
        }
        
        // Update minus button - search within the same cart item first
        let minusBtn = cartItem.querySelector(`.js-minus[data-key="${itemKey}"]`);
        if (!minusBtn) {
            minusBtn = cart.querySelector(`.js-minus[data-key="${itemKey}"]`);
        }
        if (!minusBtn) {
            minusBtn = cart.querySelector(`button.js-minus[data-key="${escapedItemKey}"]`);
        }
        if (minusBtn) {
            const oldAriaLabel = minusBtn.getAttribute('aria-label');
            const newAriaLabel = `${productInfo}. Remove 1 unit from bag`;
            minusBtn.setAttribute('aria-label', newAriaLabel);
            console.log('✓ Updated minus button:', {
                old: oldAriaLabel,
                new: newAriaLabel
            });
        } else {
            console.error('✗ Minus button not found for itemKey:', itemKey);
        }
        
        // Update plus button - search within the same cart item first
        let plusBtn = cartItem.querySelector(`.js-plus[data-key="${itemKey}"]`);
        if (!plusBtn) {
            plusBtn = cart.querySelector(`.js-plus[data-key="${itemKey}"]`);
        }
        if (!plusBtn) {
            plusBtn = cart.querySelector(`button.js-plus[data-key="${escapedItemKey}"]`);
        }
        if (plusBtn) {
            const oldAriaLabel = plusBtn.getAttribute('aria-label');
            const newAriaLabel = `${productInfo}. Add 1 unit to bag`;
            plusBtn.setAttribute('aria-label', newAriaLabel);
            console.log('✓ Updated plus button:', {
                old: oldAriaLabel,
                new: newAriaLabel
            });
        } else {
            console.error('✗ Plus button not found for itemKey:', itemKey);
        }
        
        // Update remove button - search within the same cart item first
        let removeBtn = cartItem.querySelector(`.js-remove[data-key="${itemKey}"]`);
        if (!removeBtn) {
            removeBtn = cart.querySelector(`.js-remove[data-key="${itemKey}"]`);
        }
        if (!removeBtn) {
            removeBtn = cart.querySelector(`button.js-remove[data-key="${escapedItemKey}"]`);
        }
        if (removeBtn) {
            const oldAriaLabel = removeBtn.getAttribute('aria-label');
            const newAriaLabel = `${productInfo}. Remove all from cart`;
            removeBtn.setAttribute('aria-label', newAriaLabel);
            removeBtn.setAttribute('data-item-title', fullProductDescription);
            console.log('✓ Updated remove button:', {
                old: oldAriaLabel,
                new: newAriaLabel
            });
        } else {
            console.error('✗ Remove button not found for itemKey:', itemKey);
        }
        
        // Update quantity value aria-label
        const quantity = quantityValue.textContent.trim();
        const newQuantityAriaLabel = `${productInfo}. Quantity: ${quantity} ${quantity === '1' ? 'item' : 'items'} in bag`;
        quantityValue.setAttribute('aria-label', newQuantityAriaLabel);
    });
    
    console.log('=== updateButtonAriaLabels completed ===\n');
}

function announceToScreenReader(message, priority = 'polite') {
    // Remove existing live region if present
    let liveRegion = document.getElementById('cart-announcements');
    if (!liveRegion) {
        liveRegion = document.createElement('div');
        liveRegion.id = 'cart-announcements';
        liveRegion.setAttribute('role', priority === 'assertive' ? 'alert' : 'status');
        liveRegion.setAttribute('aria-live', priority);
        liveRegion.setAttribute('aria-atomic', 'true');
        liveRegion.className = 'sr-only';
        document.body.appendChild(liveRegion);
    } else {
        // Update role and aria-live based on priority
        liveRegion.setAttribute('role', priority === 'assertive' ? 'alert' : 'status');
        liveRegion.setAttribute('aria-live', priority);
    }
    
    // Update and announce
    liveRegion.textContent = message;
    
    // Clear after announcement (longer delay for assertive messages)
    const delay = priority === 'assertive' ? 2000 : 1000;
    setTimeout(() => {
        liveRegion.textContent = '';
    }, delay);
}

// Focus trap for cart - keeps focus within cart when open (ADA compliance)
function setupCartFocusTrap() {
    const cart = document.querySelector('.js-cart');
    if (!cart) return;
    
    // Get all focusable elements within cart - includes custom elements like ReDo
    const getFocusableElements = (container) => {
        const focusableSelectors = [
            'a[href]',
            'button:not([disabled])',
            'textarea:not([disabled])',
            'input:not([disabled])',
            'select:not([disabled])',
            '[tabindex]:not([tabindex="-1"])'  // This catches custom elements like redo-shopify-toggle
        ].join(', ');
        
        let elements = Array.from(container.querySelectorAll(focusableSelectors));
        
        // Explicitly include ReDo custom element - it might not be caught by querySelector
        const redoToggle = container.querySelector('redo-shopify-toggle');
        if (redoToggle && !elements.includes(redoToggle)) {
            const tabindex = redoToggle.getAttribute('tabindex');
            if (tabindex !== '-1') {
                elements.push(redoToggle);
            }
        }
        
        return elements.filter(el => {
            // For custom elements like redo-shopify-toggle, be lenient with visibility checks
            const isCustomElement = el.tagName && el.tagName.includes('-');
            if (isCustomElement) {
                // Custom elements might have zero dimensions but still be focusable
                return !el.hasAttribute('aria-hidden') && 
                       !el.closest('[aria-hidden="true"]') &&
                       window.getComputedStyle(el).visibility !== 'hidden' &&
                       window.getComputedStyle(el).display !== 'none';
            }
            
            // For regular elements, check dimensions
            return el.offsetWidth > 0 && el.offsetHeight > 0 && 
                   !el.hasAttribute('aria-hidden') && 
                   !el.closest('[aria-hidden="true"]') &&
                   window.getComputedStyle(el).visibility !== 'hidden' &&
                   window.getComputedStyle(el).display !== 'none';
        });
    };
    
    const handleKeyDown = (e) => {
        // Only trap if cart is open
        if (!document.body.classList.contains('cart--open')) {
            return;
        }
        
        // Handle Tab key - refresh focusables on every Tab to catch dynamically added elements
        if (e.key === 'Tab') {
            const focusableElements = getFocusableElements(cart);
            if (focusableElements.length === 0) return;
            
            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];
            const active = document.activeElement;
            const redo = cart.querySelector('redo-shopify-toggle');
            
            // Check if focus is outside the cart
            const isOutsideCart = !cart.contains(active);
            
            // Special handling: if we're on ReDo host, allow Tab to proceed normally
            // BUT catch if it escapes and bring it back
            if (active === redo && !e.shiftKey) {
                // Let the browser try to move focus, but check if it escapes
                setTimeout(() => {
                    const newActive = document.activeElement;
                    if (!cart.contains(newActive) && newActive !== document.body) {
                        // Focus escaped, bring it back to first
                        firstElement.focus();
                    }
                }, 0);
                // Don't prevent default - let ReDo/browser handle it first
                return;
            }
            
            // If Shift+Tab on first element or outside cart, move to last
            if (e.shiftKey) {
                if (active === firstElement || isOutsideCart || (!focusableElements.includes(active) && active !== document.body)) {
                    e.preventDefault();
                    lastElement.focus();
                }
            }
            // If Tab on last element or outside cart, move to first
            else {
                // If focus escaped the cart, bring it back
                if (isOutsideCart || (!focusableElements.includes(active) && active !== document.body && active !== cart)) {
                    e.preventDefault();
                    firstElement.focus();
                }
                // If we're on the last element (but not ReDo, which is handled above), wrap to first
                else if (active === lastElement && active !== redo) {
                    e.preventDefault();
                    firstElement.focus();
                }
            }
        }
        
        // Handle Escape key - close cart
        if (e.key === 'Escape') {
            const closeBtn = document.querySelector('.js-close-cart');
            if (closeBtn) {
                e.preventDefault();
                closeBtn.click();
            }
        }
    };
    
    // Remove existing listener if present
    cart.removeEventListener('keydown', handleKeyDown);
    
    // Add focus trap listener
    cart.addEventListener('keydown', handleKeyDown);
}

// Initialize focus trap when cart opens
// Click outside cart to close
function setupClickOutsideToClose() {
    document.addEventListener('click', function(e) {
        // Only handle if cart is open
        if (!document.body.classList.contains('cart--open')) {
            return;
        }
        
        const cart = document.querySelector('.js-cart');
        if (!cart) return;
        
        // Don't close if clicking on the close button itself (it handles its own click)
        if (e.target.closest('.js-close-cart')) {
            return;
        }
        
        // Check if click is inside the cart
        if (cart.contains(e.target)) {
            return; // Click is inside cart, don't close
        }
        
        // Click is outside the cart, close it
        const closeBtn = document.querySelector('.js-close-cart');
        if (closeBtn) {
            closeBtn.click();
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    // Setup click outside to close
    setupClickOutsideToClose();
    
    // Watch for cart opening
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                if (document.body.classList.contains('cart--open')) {
                    // Initial setup
                    setTimeout(() => {
                        setupCartFocusTrap();
                        setupCartTabOrder();
                    }, 200);
                    // Single retry to catch async injections
                    setTimeout(() => setupCartTabOrder(), 1000);
                }
            }
            
            // Watch for dynamically added elements (like ReDo, Checkout+ buttons)
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                if (document.body.classList.contains('cart--open')) {
                    // Check if any added nodes are buttons, scripts, iframes, or contain buttons
                    let hasInteractiveElements = false;
                    let hasScript = false;
                    let hasIframe = false;
                    
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeType === 1) { // Element node
                            if (node.tagName === 'BUTTON' || 
                                node.tagName === 'A' || 
                                node.querySelector('button, a[href], [role="button"]')) {
                                hasInteractiveElements = true;
                            }
                            if (node.tagName === 'SCRIPT') {
                                hasScript = true;
                            }
                            if (node.tagName === 'IFRAME') {
                                hasIframe = true;
                            }
                        }
                    });
                    
                    if (hasInteractiveElements || hasScript || hasIframe) {
                        // Single retry to catch async injections
                        setTimeout(() => setupCartTabOrder(), 500);
                    }
                }
            }
        });
    });
    
    observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        subtree: true
    });
    
    // Also observe the cart container for dynamically added elements
    const cart = document.querySelector('.js-cart');
    if (cart) {
        observer.observe(cart, {
            childList: true,
            subtree: true
        });
    }
    
    // Also set up immediately if cart is already open
    if (document.body.classList.contains('cart--open')) {
        setupCartFocusTrap();
        setupCartTabOrder();
    }
    
});

const cartOpeners = document.querySelectorAll(".js-open-cart");

if (cartOpeners.length) {
    cartOpeners.forEach((trigger) => {

        const action = trigger.getAttribute('data-cart-action') || 'drawer';
        const shouldReturnFocus = trigger.hasAttribute('data-cart-return-focus');
    trigger.addEventListener("click", function (e) {
            if (action === 'drawer') {
        e.preventDefault();
        document.body.classList.add("cart--open");

        Shopify.theme.cart.getState().then(state => {
            rebuildCart(state);

            // CRITICAL: Move focus to cart for ADA compliance
            setTimeout(() => {
                focusCartOnOpen();
            }, 150);
        });
            }
            if (action === 'navigate' && shouldReturnFocus) {
                try {
                    sessionStorage.setItem('header-cart-return-focus', 'true');
                } catch (err) {
                    // ignore
                }
            }
        });

    });
}

if (document.querySelector(".js-close-cart")) {
    var trigger = document.querySelector(".js-close-cart");
    trigger.addEventListener("click", function (e) {
        e.preventDefault();
        
        // Store the element that opened the cart for focus return
        const previousFocus = document.querySelector('.js-open-cart:focus, [data-cart-action="drawer"]:focus') || 
                             document.activeElement;
        
        document.body.classList.remove("cart--open");
        
        // CRITICAL: Return focus to the element that opened the cart (ADA compliance)
        setTimeout(() => {
            if (previousFocus && previousFocus !== document.body) {
                previousFocus.focus();
            }
        }, 100);
    });
}



// Checkout button is handled by injected Checkout+ app - no custom handler needed
// Gift message is still saved via cart note when items are updated

const item_triggers = document.querySelectorAll('.js-add-item')

for (const item_trigger of item_triggers) {

    item_trigger.addEventListener('click', function (e) {
        e.preventDefault();
        
        Shopify.theme.cart.addItem(item_trigger.dataset.id).then(item => {
            document.body.classList.add("cart--open");
            Shopify.theme.cart.getState().then(state => {
                rebuildCart(state);
                
                // CRITICAL: Move focus to cart for ADA compliance
                setTimeout(() => {
                    focusCartOnOpen();
                }, 150);
            });
        });

    })
// Sync: Fixed button aria-labels to reference correct cart item - 2024
}// Version: 1764172200 - Quantity alignment sync trigger v9
